import { DashboardService } from '../../../../../service/events/dashboard.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseForm } from '../../../../base-form';
import { PlanAbonadoFormDefinition } from './form-control/form-definition';
import { TareasApiService } from '../../../../../service/api/tareas-api.service';
import { FincasApiService } from '../../../../../service/api/fincas-api.service';
import { ProductosApiService } from '../../../../../service/api/productos-api';
import { TrabajadoresApiService } from '../../../../../service/api/trabajadores-api.service';
import { ClientesApiService } from '../../../../../service/api/clientes-api.service';
import { Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { SiexApiService } from '../../../../../service/api/siex-api.service';
import { ReactiveFormBuilderComponent } from 'src/app/common/components/reactive-form-builder/form-builder.component';
import { PlanAbonadoModel } from 'src/app/models/tareas/plan-abonado.model';
import { build, pool } from 'src/app/common/classes/request-builder';
import { FormPhase } from 'src/app/common/components/reactive-form-builder/form-request';
@Component({
  selector: 'app-plan-abonado-form',
  standalone: false,
  templateUrl: './plan-abonado-form.component.html',
  styleUrls: ['./plan-abonado-form.component.scss'],
})
export class PlanAbonadoFormComponent extends BaseForm<PlanAbonadoModel> implements OnInit, OnDestroy {
  public loadingData = true;

  public dropdownLoadTrigger = new Subject<void>();

  public form!: PlanAbonadoFormDefinition;

  public formRequest: ReactiveFormBuilderComponent<PlanAbonadoModel>;

  public getRequest = this.tareasApi.planAbonado.GET;

  constructor(
    public fincasApi: FincasApiService,
    public siexApi: SiexApiService,
    public tareasApi: TareasApiService,
    public productosApi: ProductosApiService,
    public trabajadoresApi: TrabajadoresApiService,
    public override router: Router,
    public override route: ActivatedRoute,
    public dashboardEvents: DashboardService,
    public clientesApi: ClientesApiService,
    private readonly http: HttpClient
  ) {
    super(
      route,
      router,
      dashboardEvents,
      tareasApi.planAbonado.PUT,
      tareasApi.planAbonado.POST,
      'plan-abonado',
      'Editar Plan de Abonado',
      'Realizar Plan de Abonado',
      'Duplicar Plan de Abonado'
    );
    this.formRequest = new ReactiveFormBuilderComponent(this.http);
  }

  public ngOnInit(): void {
    this.form = new PlanAbonadoFormDefinition(this.getType(), this.getModel() as Record<string, string>, null);
    this.initFormData();
    this.softInit(this.getType());
    this.form.requestType = this.getType();
  }

  formChanges(formModel: [object, string], tag: string): void {
    this.form.model = formModel as unknown as PlanAbonadoModel;
    this.form.tag = tag;
  }

  private initFormData(): Promise<unknown> {
      const buildsRequest = [
        build(this.siexApi.cultivosGET, this.form.lists.cultivos, 'cultivo', true)
      ];
  
      return pool(buildsRequest, () => {
        this.formRequest.executePhase(FormPhase.UPDATE);
      }).then(() => {
        this.dropdownLoadTrigger.next();
        this.loadingData = false;
        return;
      })
        .catch((e) => {
          console.log('catch en pool: ' + e);
        });
    }
}
